export const CLIENT_SEARCH_PARAMETERS = [
  {
    id: 1,
    text: 'Código',
    parameter: 'id_entidade',
  },
  {
    id: 2,
    text: 'Nome',
    parameter: 'razao_social_nome',
  },
  {
    id: 3,
    text: 'CNPJ/CPF',
    parameter: 'cnpjcpf',
  },
  {
    id: 4,
    text: 'Cidade',
    parameter: 'c.nome',
  },
]
